@if (currentUserService.isSuperAdmin()) {
  @if (isCollapsed) {
    <!-- Collapsed mode: compact icon with tooltip -->
    <button
      type="button"
      class="flex h-12 w-12 items-center justify-center cursor-pointer rounded-lg hover:bg-primary-50 transition-colors duration-200 relative border-0 bg-transparent"
      [pTooltip]="tooltipText"
      tooltipPosition="right"
      (click)="onCollapsedClick()"
    >
      <i class="pi pi-building text-greyscale-500" style="font-size: 1.25rem;"></i>
      @if (isActingAsOther) {
        <span
          class="absolute top-1 right-1 h-2.5 w-2.5 rounded-full bg-orange-500"
          role="img"
          [attr.aria-label]="'admin.actingAsOtherCompany' | transloco"
        ></span>
      }
    </button>
  } @else {
    <!-- Expanded mode: full selector with icon on left -->
    <div class="p-3 rounded-lg bg-[var(--p-surface-50)]">
      <div class="flex items-center gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white">
          <i class="pi pi-building text-greyscale-500" style="font-size: 1rem;"></i>
        </div>
        <div class="flex-1 min-w-0">
          <p-select
            [options]="companies"
            [(ngModel)]="selectedCompanyId"
            (ngModelChange)="onCompanyChange($event)"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'admin.selectCompany' | transloco"
            styleClass="w-full"
            [loading]="isLoading"
            [filter]="true"
            filterBy="label"
            appendTo="body"
          />
        </div>
      </div>
      @if (isActingAsOther) {
        <div class="mt-2 flex items-center gap-1 text-xs text-orange-600">
          <i class="pi pi-exclamation-circle"></i>
          <span>{{ 'admin.actingAsOtherCompany' | transloco }}</span>
        </div>
      }
    </div>
  }
}
